import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { PayScalesService } from '../../pay-scales.service';
import { IAircraftModel, IJobTitle, IPayScale, IPayScaleEffectiveDate } from '../../pay-scales.types';

/**
 * Handles display of pay tables details card
 */
@Component({
	selector: 'app-pay-scales-details-card',
	styleUrls: ['./pay-scales-details-card.component.scss'],
	templateUrl: './pay-scales-details-card.component.html'
})
export class PayScalesDetailsCardComponent implements OnInit, OnChanges {
	/**
	 *
	 */
	constructor(payScalesService: PayScalesService) {
		this.payScalesService = payScalesService;
		this.getAircraftModel();
		this.getJobTitles();
	}

	@Input() public payScale: IPayScale;
	@Input() public effectiveStart: IPayScaleEffectiveDate;
	@Output() public onChange: EventEmitter<IPayScale> = new EventEmitter();
	public payScalesService: PayScalesService;
	public aircraftModels: IAircraftModel[] = [];
	public filteredAircraftModels: IAircraftModel[] = [];
	public jobTitles: IJobTitle[] = [];
	public filteredJobTitles: IJobTitle[] = [];

	/**
	 *
	 */
	public ngOnInit(): void {
		if (!this.payScale) {
			return;
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['effectiveStart'] && this.effectiveStart) {
			this.setFilteredJobTitles();
			this.setFilteredAirCrafts();
		}
	}

	/**
	 * getAircraftModel
	 */
	public getAircraftModel(): void {
		this.payScalesService.getAircraftModel().subscribe(
			(DATA: IAircraftModel[]) => {
				if (DATA) {
					this.aircraftModels = DATA;
					this.setFilteredAirCrafts();
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	/**
	 * getJobTitles
	 */
	public getJobTitles(): void {
		this.payScalesService.getJobTitles().subscribe(
			(DATA: IJobTitle[]) => {
				if (DATA) {
					this.jobTitles = DATA;
					this.setFilteredJobTitles();
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public setFilteredJobTitles(): void {
		this.filteredJobTitles = this.jobTitles.filter(
			j => new Date(j.effectiveStart) <= new Date(this.effectiveStart.internalFormat)
		);
	}

	public setFilteredAirCrafts(): void {
		this.filteredAircraftModels = this.aircraftModels.filter(
			a => new Date(a.effectiveStart) <= new Date(this.effectiveStart.internalFormat)
		);
	}

	/**
	 * isNeedChange
	 */
	public isNeedChange(): void {
		this.onChange.emit(this.payScale);
	}
}
